"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoterV1 = exports.newVoterV1 = void 0;
const connect_1 = require("@celo/connect");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const SavingsCELOVoterV1_1 = require("../types/web3-v1-contracts/SavingsCELOVoterV1");
async function newVoterV1(kit, savingsKit) {
    const voterV1Address = await savingsKit.contract.methods._voter().call();
    const voterV1 = new VoterV1(kit, savingsKit, voterV1Address);
    const proxyAddr = await voterV1.contract.methods._proxy().call();
    if (proxyAddr !== savingsKit.contractAddress) {
        new Error(`voterV1 _proxy: ${proxyAddr} != savingsCELO ${savingsKit.contractAddress}`);
    }
    return voterV1;
}
exports.newVoterV1 = newVoterV1;
class VoterV1 {
    constructor(kit, savingsKit, contractAddress) {
        this.kit = kit;
        this.savingsKit = savingsKit;
        this.contractAddress = contractAddress;
        this.changeVotedGroup = async (newGroup) => {
            const votedGroup = await this.contract.methods.votedGroup().call();
            const election = await this.kit.contracts.getElection();
            const groups = await election.getGroupsVotedForByAccount(this.savingsKit.contractAddress);
            let votedGroupIndex = groups.indexOf(votedGroup);
            let pendingRevoke = {
                lesser: "0x0000000000000000000000000000000000000000",
                greater: "0x0000000000000000000000000000000000000000",
            };
            let activeRevoke = {
                lesser: "0x0000000000000000000000000000000000000000",
                greater: "0x0000000000000000000000000000000000000000",
            };
            if (votedGroupIndex >= 0) {
                const votes = await election.getVotesForGroupByAccount(this.savingsKit.contractAddress, votedGroup);
                pendingRevoke = await election.findLesserAndGreaterAfterVote(votes.group, votes.pending.negated());
                activeRevoke = await election.findLesserAndGreaterAfterVote(votes.group, votes.pending.plus(votes.active).negated());
            }
            else {
                votedGroupIndex = 0;
            }
            const txo = this.contract.methods.changeVotedGroup(newGroup, votedGroupIndex, pendingRevoke.lesser, pendingRevoke.greater, activeRevoke.lesser, activeRevoke.greater);
            return (0, connect_1.toTransactionObject)(this.kit.connection, txo);
        };
        this.activateAndVote = async () => {
            const votedGroup = await this.contract.methods.votedGroup().call();
            const election = await this.kit.contracts.getElection();
            const toVote = await this.calcToVote();
            const { lesser, greater } = await election.findLesserAndGreaterAfterVote(votedGroup, toVote);
            const txo = this.contract.methods.activateAndVote(lesser, greater);
            return (0, connect_1.toTransactionObject)(this.kit.connection, txo);
        };
        this.needsActivateAndVote = async () => {
            const savingsCELOAddress = await this.contract.methods._proxy().call();
            const election = await this.kit.contracts.getElection();
            const mustActivate = await election.hasActivatablePendingVotes(savingsCELOAddress);
            if (mustActivate) {
                return true;
            }
            const toVote = await this.calcToVote();
            return toVote.gt(0);
        };
        this.calcToVote = async () => {
            const savingsCELOAddress = await this.contract.methods._proxy().call();
            const votedGroup = await this.contract.methods.votedGroup().call();
            const election = await this.kit.contracts.getElection();
            const lockedGold = await this.kit.contracts.getLockedGold();
            const toVote = await lockedGold.getAccountNonvotingLockedGold(savingsCELOAddress);
            const groupVotes = await election.getValidatorGroupVotes(votedGroup);
            return bignumber_js_1.default.minimum(toVote, groupVotes.capacity);
        };
        this.contract = new kit.web3.eth.Contract(SavingsCELOVoterV1_1.ABI, contractAddress);
    }
}
exports.VoterV1 = VoterV1;
//# sourceMappingURL=voterv1.js.map